import { asMultiStyleConfig } from '../../../../utils/theme';
import { getColor } from '../../../../theme-tools';
var parts = ['colorList', 'colorItem'];
var colorItem = props => {
  var {
    theme
  } = props;
  return {
    borderRadius: 0,
    _pressed: {
      border: "3px solid ".concat(getColor(theme, 'grey.980')),
      boxShadow: "0 0 0 3px ".concat(getColor(theme, 'yellow.200'))
    },
    _focus: {
      outline: 'none',
      boxShadow: "0 0 0 3px ".concat(getColor(theme, 'yellow.200')),
      border: "1px solid ".concat(getColor(theme, 'grey.980'))
    }
  };
};
var baseStyle = props => {
  var {
    theme
  } = props;
  return {
    colorList: {
      boxShadow: 'none',
      borderRadius: 0,
      border: "1px solid ".concat(getColor(theme, 'grey.450'))
    },
    colorItem: colorItem(props)
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});